module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/forbidSuccess.eeafb1e4.svg";